import React, { Fragment } from 'react';
import { Col, Input, Label, Row, UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// The way the BE handles this requires the FE to hard-code everything since
// the presence of the object determines if the object is checked...
const CARD_ARRAY = [
  { id: 3, name: 'Visa' },
  { id: 4, name: 'MasterCard' },
  { id: 5, name: 'Discover' },
  { id: 6, name: 'American Express' }
];

const PaymentOptions = ({ currency, handlePaymentMethodCheckbox, paymentMethods }) => (
  <Fragment>
    <h3>
      Sale Details &amp; Payment Options&nbsp;
      <FontAwesomeIcon id="saleDetailsIcon" className="color-blue" icon="question-circle" />
      <UncontrolledTooltip placement="right" target="saleDetailsIcon">
        This is the currency your WePay account is set up with.
      </UncontrolledTooltip>
    </h3>

    <p className="font-weight-bold mt-2 mb-0">Currency</p>
    <p>
      {currency.name} ({currency.code})
    </p>

    <Row>
      <Col xs={1}>
        <span className="fa-layers fa-fw fa-3x">
          <FontAwesomeIcon icon="circle" className="color-primary" />
          <FontAwesomeIcon icon="credit-card" inverse transform="shrink-8" color="white" />
        </span>
      </Col>
      <Col xs={11}>
        <strong>You are enrolled in online payment processing</strong>
        <p>Eligible buyers have the option to pay you directly online via credit card.</p>
      </Col>
    </Row>

    <p className="font-weight-bold mb-2">Payment Options*</p>
    {CARD_ARRAY.map(card => (
      <div className="mt-1 d-flex" key={card.id}>
        <Input
          id={`card-${card.id}`}
          defaultChecked={paymentMethods.find(payment => payment.id === card.id)}
          className="ml-0 mt-1 position-relative"
          onChange={() => handlePaymentMethodCheckbox(card)}
          type="checkbox"
        />
        <Label className="ml-2" for={`card-${card.id}`}>
          {card.name}
        </Label>
      </div>
    ))}
    {paymentMethods.length === 0 && <p className="color-danger my-0">Please select at least one payment method</p>}
  </Fragment>
);

export default PaymentOptions;
